import { createContext } from 'react';
import type { TI18nContextValue } from './I18n.types.ts';

export const I18nContext = createContext<TI18nContextValue | undefined>(
  undefined,
);
